import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import { useRole } from 'components/Hooks/UserHooks';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import HighlightText from 'pages/News/Components/HighlightText';
import SpinnerScreen from 'pages/News/Components/SpinnerScreen';
import React, { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { CardBody, CardHeader, Col, Row, Spinner } from "reactstrap";
import { getInfoWeatherWarning, postGenerateWeatherWarningNews } from "../../../store/thunks";
import ModalConfigGenerate from './components/ModalConfigGenerate';
import ModalGenerate from './components/ModalGenerate';
import ModalImport from './components/ModalImport';

export interface Tag {
    id: string;
    text: string;
}

const TYPE_SELECT_DEFAULT: string = 'popularity';

registerLocale('en', en);
registerLocale('ko', ko);

const WeatherPlace = (activeTab?: any) => {
    let document_w: any = window.document;
    const { t, i18n } = useTranslation();
    const { userPermissions } = useRole();

    const [infoWeather, setInfoWeather] = useState<any>(null);

    const [isGenerating, setIsGenerating] = useState<boolean>(false);

    const [isLoadingInfoWeather, setIsLoadingInfoWeather] = useState<boolean>(false);

    const [isOpenModalImport, setIsOpenModalImport] = useState<boolean>(false);

    const [isOpenModalGenerate, setIsOpenModalGenerate] = useState<boolean>(false);

    const [isOpenModalConfigPrompt, setIsOpenModalConfigPrompt] = useState<boolean>(false);

    const searchData = async () => {
        try {
            setIsLoadingInfoWeather(true);
            const res: any = await getInfoWeatherWarning({});
            setInfoWeather(res?.data || null);
            setIsLoadingInfoWeather(false);
        } catch (error: any) {
            return error;
        }
    };

    const resetData = () => {
        setInfoWeather(null);
    };

    const triggerRefresh = async () => {
        setIsOpenModalGenerate(false);
    }
    //End::Update

    const handleGenerateWeatherWarningNews = async (values: any) => {
        try {
            if (isGenerating) return;
            setIsGenerating(true);
            const response: any = await postGenerateWeatherWarningNews({});
            setIsGenerating((_prev) => false);
            if (response?.code === 200) {
                toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
            } else {
                toast(`${response || ""}`, CONFIG_OPTION_TOAST_ERROR);
            }

        } catch (error: any) {
            setIsGenerating((_prev) => false);
            toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
            return error;
        }
    };

    useEffect(() => {
        document.body.classList.remove('vertical-sidebar-enable');
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [i18n?.language]);

    return (
        <React.Fragment>
            <Row>
                {isHavePermissionRole(ROLES_FOR_APP.NEWS_WEATHER, userPermissions) && (
                    <Col lg={12}>
                        <div>
                            <CardHeader className="border-0">
                                <Row className="g-4 align-items-center">
                                    <div className="col-sm-5">
                                        <div>
                                            <h5 className="card-title mb-0">
                                                <span>
                                                    {/* <span className="me-2">{t('City')}:</span>
                                                    {(isLoadingInfoWeather) ? <Spinner size="sm" className="text-primary"></Spinner> : (<span className="text-muted">
                                                        {citySearch?.map((item: any) => item.value).join(', ')}
                                                    </span>)} */}
                                                </span>
                                            </h5>
                                        </div>
                                    </div>
                                    <div className="col-sm-7 text-end">
                                        {/* {isHavePermissionRole(ROLES_FOR_APP.NEWS_WEATHER, userPermissions) && (<button
                                            type="button"
                                            className="btn btn-success add-btn rounded-pill mb-2 mb-sm-0"
                                            onClick={() => handleShowModalImport()}
                                        >
                                            <i className="ri-upload-line align-bottom"></i>
                                            <span className="ms-1">{t('Button Import Bulk Generate Weather News')}</span>
                                        </button>)} */}
                                        {isHavePermissionRole(ROLES_FOR_APP.NEWS_WEATHER_WARNING, userPermissions) && (<button
                                            type="button"
                                            className="btn btn-success add-btn rounded-pill mb-2 mb-sm-0"
                                            onClick={() => handleGenerateWeatherWarningNews({})}
                                            disabled={isGenerating}
                                        >
                                            {isGenerating ? <Spinner size="sm" className="text-white"></Spinner> : <i className="ri-refresh-line align-bottom"></i>}
                                            <span className="ms-1">{t('Button Generate Weather Warning News')}</span>
                                        </button>)}
                                        {isHavePermissionRole(ROLES_FOR_APP.CONFIGURATION_BOOSTING_NEWS_WEATHER, userPermissions) && (<button
                                            type="button"
                                            className="btn btn-primary add-btn rounded-pill ms-2"
                                            onClick={() => setIsOpenModalConfigPrompt((_prev: any) => true)}
                                        >
                                            <i className="ri-settings-line align-bottom"></i>
                                            <span className="ms-1">{t('Config Generate')}</span>
                                        </button>)}
                                    </div>
                                </Row>
                            </CardHeader>
                            <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                                <Row className="g-4 align-items-center mt-1">
                                    <Col sm={12} className="hstack gap-1 justify-content-center justify-content-lg-start mt-3 mt-xl-2">
                                        <div>
                                            <button
                                                type="button"
                                                className="btn btn-info me-2 "
                                                onClick={searchData}
                                                disabled={isLoadingInfoWeather}
                                            >
                                                <i className="ri-search-line align-bottom me-1"></i>{" "}
                                                {t('Button Search Weather Warning Info')}
                                            </button>
                                            <button
                                                type="button"
                                                className="btn btn-secondary fs-14"
                                                disabled={isLoadingInfoWeather}
                                                onClick={resetData}
                                            >
                                                <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                                                {t('Button Reset')}
                                            </button>
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                            {/* <div className="border border-dashed border-top-0 border-end-0 border-start-0 px-3 py-3">
                                <Col sm={12} md={12} xl={12} className="my-0 mt-2 mt-md-0 text-start d-flex flex-wrap gap-3 justify-content-between align-items-center">
                                    {isHavePermissionRole(ROLES_FOR_APP.KEYWORD_TASK_UPDATE, userPermissions) && <div
                                        className='d-flex flex-wrap gap-3 justify-content-between align-items-center'
                                    >
                                        <button
                                            type="button"
                                            className="btn btn-soft-success"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleShowModalGenerate();
                                            }}
                                        >
                                            {t('Generate News')}
                                        </button>
                                    </div>}
                                    <div className="mt-3 mt-md-0">

                                    </div>
                                </Col>
                            </div> */}
                            <CardBody className="pt-3 position-relative" style={{ minHeight: '50dvh', maxHeight: '50dvh', overflowY: 'auto' }}>
                                {isLoadingInfoWeather ? <SpinnerScreen zIndex={9} isShow={true} textLoading={t('Getting Weather Info')} /> : (
                                    <>
                                        {!!infoWeather ? <div style={{ whiteSpace: 'pre-line', lineHeight: '170%', }}>
                                            <HighlightText text={infoWeather?.full_text || ''} keyword={infoWeather?.keyword || ''} is_highlight_date={true} />
                                        </div> :
                                            <div className="d-flex align-items-center justify-content-center" style={{ height: '40dvh' }}>
                                                <span className="text-muted fs-13">
                                                    {t('No Weather Warning Info')}
                                                </span>
                                            </div>}
                                    </>
                                )}
                            </CardBody>
                        </div>
                    </Col>
                )}
            </Row>

            <ModalConfigGenerate
                isOpen={isOpenModalConfigPrompt}
                onClose={() => setIsOpenModalConfigPrompt((_prev: any) => false)}
            />

            <ModalGenerate
                isOpen={isOpenModalGenerate}
                onClose={() => setIsOpenModalGenerate(false)}
                onRefresh={() => triggerRefresh()}
            />

            <ModalImport
                isOpen={isOpenModalImport}
                onRefresh={triggerRefresh}
                onClose={() => setIsOpenModalImport(false)}
            />

            <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={3000} limit={2} />
        </React.Fragment >
    );
};

export default WeatherPlace;